<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t('common.shops') }}
      <v-btn
          color="success"
          class="ml-1 green-shadow"
          x-small
          fab
          max-width="26"
          max-height="26"
          :loading="!fetched"
          :disabled="!fetched"
          :title="$t('common.add')"
          @click="addShopDialog = !addShopDialog"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h3>
    <v-dialog v-model="addShopDialog" scrollable max-width="600px">
      <v-card class="pa-3">
        <h3 class="pa-3 pt-2">{{ $t('viewShops.creating_new') }}</h3>
        <v-form ref="creatingNewShopForm">
          <v-layout class="px-3 pb-2">
            <v-row>
              <v-col cols="12">
                <v-text-field
                    outlined
                    v-model="legal_name"
                    :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                    :label="$t('common.legal_name')"
                ></v-text-field>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" class="text-right px-0 py-0">
                <v-btn
                    :disabled="savingInProgress"
                    :loading="savingInProgress"
                    class="mr-2 mt-4"
                    color="primary"
                    elevation="0"
                    @click="submit"
                    @keyup.enter="submit"
                >
                  {{ $t('common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
    <v-data-table
        :headers="shopsTableHeader"
        :items="shops"
        elevation="0"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">{{ props.item.legal_name }}</td>
          <td class="text-xs-left">

          </td>
          <td class="text-xs-left">

          </td>
          <td class="text-right text-no-wrap">
            <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="primary"
                class="mb-0 ml-3 px-0 white--text"
                @click="changeActiveShop(props.item)"
            >
              <v-icon small v-if="activeShopId===props.item.id">$check</v-icon>
              <v-icon small v-else>fa-store-alt</v-icon>
            </v-btn>


          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapFields } from 'vuex-map-fields';
export default {
  data: () => ({
    addShopDialog:false,
    legal_name:''
  }),
  mounted(){
    this.$store.dispatch('shops/get')
  },
  computed: {
    ...mapFields('auth', ['authenticatedUser']),
    ...mapFields('shops', ['shops', 'fetched', 'savingInProgress']),
    activeShopId(){
      return this.authenticatedUser.active_shop_id;
    },
    shopsTableHeader() {
      return [
        {text: this.$t('common.legal_name'), value: 'legal_name', sortable: true},
      ];
    },
  },
  methods: {
    submit(){
      if(this.$refs['creatingNewShopForm'].validate()) {
        this.$store.dispatch('shops/store', {legal_name: this.legal_name}).
        then((result)=>{
          if(result){
            this.addShopDialog = false;
          }
          this.$store.dispatch('shops/get');
          this.$store.dispatch('auth/check');
        });
      }
    },
    changeActiveShop(shop){
      if(shop.id === this.authenticatedUser.active_shop_id) return;
      this.$store.dispatch('auth/changeActiveShop', shop.id).then(()=>{
        document.location.reload();
      })
    },
  },
}
</script>